<template>
  <scrollbar
    :speed="83"
    ref="scrollbar"
    class="sidebar"
    :style="sideBarColors"
    :class="{ open: open }"
  >
    <ul
      class="menu"
      :style="`--background: ${
        this.theme.activo ? this.theme.sidebar : '#011c21'
      }; --color: ${
        this.theme.activo ? this.theme.fuenteiconos : '#ffffffb3'
      };`"
    >
      <!-- Usuario -->
      <div class="user">
        <div class="avatar">
          <span class="acronym">{{
            $store.getters["auth/userAvatarName"]
          }}</span>
          <el-popover
            :width="open ? 130 : 52"
            placement="bottom"
            trigger="click"
            v-model="userMenu"
            popper-class="sidebarUserActions"
            class="sidebarUserActions"
          >
            <el-dropdown-item @click.native="profile"
              ><i class="fas fa-user"></i
              ><span class="ml-2" :class="{ hidden: !open }">{{
                $t("profileS")
              }}</span></el-dropdown-item
            >
            <el-dropdown-item @click.native="logout"
              ><i class="fas fa-power-off text-danger"></i
              ><span
                v-if="open"
                class="text-danger ml-2"
                :class="{ hidden: !open }"
                >{{ $t("leave") }}</span
              ></el-dropdown-item
            >
            <button class="dropdown" slot="reference">
              <i class="fa fa-angle-down"></i>
            </button>
          </el-popover>
        </div>
        <span class="name">{{
          `${user.nombre ? user.nombre.split(" ")[0] : ""} ${
            user.apellido ? user.apellido.split(" ")[0] : ""
          }`
        }}</span>
      </div>

      <!-- Menu -->
      <router-link
        tag="li"
        active-class="active"
        to="/"
        exact
        v-if="$getPermission('menu.listar')"
      >
        <div class="icon"><i class="icon-home"></i></div>
        <div class="title">{{ $t("menu.homepage.homepage") }}</div>
      </router-link>

      <!-- Nuevo caso -->
      <router-link
        tag="li"
        active-class="active"
        to="/casos/nuevo"
        exact
        v-if="$getPermission('casos.crear')"
      >
        <div class="icon"><i class="fas fa-plus-square"></i></div>
        <div class="title">{{ $t("menu.sidebar.newCase") }}</div>
      </router-link>
      
      <!-- Nuevo contacto -->
      <router-link
        tag="li"
        active-class="active"
        to="/contactos/nuevo"
        exact
        v-if="$getPermission('contactos.crear')"
      >
        <div class="icon"><i class="fas fa-user-plus"></i></div>
        <div class="title">{{ $t("menu.sidebar.newContact") }}</div>
      </router-link>
      
      <!-- Nuevo dashboard -->
      <router-link
        tag="li"
        active-class="active"
        to="/configuraciondash/nuevo"
        exact
        v-if="$getPermission('dashboard.crear')"
      >
        <div class="icon"><i class="fas fa-chart-bar"></i></div>
        <div class="title">{{ $t("menu.sidebar.newDash") }}</div>
      </router-link>

      <!-- Dashboard -->
      <li
        :class="{ active: inSubmenu.dashboardview }"
        @click="expand('dashboardview')"
        v-if="$getPermission('dashboardview.listar')"
      >
        <div class="icon"><i class="fas fa-th-large"></i></div>
        <div class="title">{{ $t("menu.sidebar.dashView") }}</div>
        <!--inSubmenu.dashboardview-->
        <ul
          class="submenu"
          v-show="!open || expanded.dashboardview"
          @click.stop=""
          v-if="$getPermission('dashboardview.listar')"
        >
          <router-link
            tag="li"
            active-class="active"
            :to="{ name: 'dashboardview', params: { id: dashviews.id } }"
            exact
            v-for="dashviews in allRedash"
            :key="dashviews.id"
          >
            <div class="title">{{ dashviews["nombre"] }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Casos -->
      <li
        :class="{ active: inSubmenu.casos }"
        @click="expand('casos')"
        v-if="$getPermission('menuCasos')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.casos' })">
          <i class="icon-drawer"></i>
        </div>
        <div class="title">{{ $t("menu.sidebar.cases") }}</div>
        <!--inSubmenu.casos-->
        <ul class="submenu" v-show="!open || expanded.casos" @click.stop="">
          <router-link
            tag="li"
            active-class="active"
            to="/casos"
            exact
            v-if="$getPermission('casos.listar')"
          >
            <div class="title">{{ $t("menu.sidebar.myCases") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/buscar"
            exact
            v-if="$getPermission('[\'casos.buscar\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.search") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisar"
            exact
            v-if="$getPermission('[\'casos.supervisar\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.supervise") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisarHistorico"
            exact
            v-if="$getPermission('[\'casos.supervisarHistorico\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.superviseHistory") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/sinasignar"
            exact
            v-if="$getPermission('[\'casos.sinAsignar\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.unassignedCases") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/cerrados"
            exact
            v-if="$getPermission('[\'casos.cerrados\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.myClosedCases") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/espera"
            exact
            v-if="$getPermission('[\'casos.espera\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.waitingCases") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/historico"
            exact
            v-if="$getPermission('[\'casos.historico\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.caseHistory") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/geolocalizacion"
            exact
            v-if="$getPermission('[\'casos.geolocalizacion\'].listar')"
          >
            <div class="title">{{ $t("menu.sidebar.caseGeo") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/miscasoscreados"
            exact
            v-if="$getPermission('[\'casos.miscasoscreados\'].listar')"
          >
            <div class="title">{{ $t("myCreatedCases.myCreatedCases") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisarProcesos"
            exact
            v-if="$getPermission('[\'casos.supervisarProcesos\'].listar')"
          >
            <div class="title">
              {{ $t("menu.sidebar.byProcessSupervision") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisarHistoricoProcesos"
            exact
            v-if="
              $getPermission('[\'casos.supervisarHistoricoProcesos\'].listar')
            "
          >
            <div class="title">
              {{ $t("menu.sidebar.byProcessHistoricSupervision") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisarEquipo"
            exact
            v-if="
              $getPermission('[\'casos.supervisarEquipo\'].listar')
            "
          >
            <div class="title">
              {{ $t("menu.sidebar.teamSupervision") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/casos/supervisarEquipoHistorico"
            exact
            v-if="
              $getPermission('[\'casos.supervisarEquipoHistorico\'].listar')
            "
          >
            <div class="title">
              {{ $t("menu.sidebar.teamSupervisionHistorico") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Clientes -->
      <li
        :class="{ active: inSubmenu.cliente }"
        @click="expand('cliente')"
        v-if="$getPermission('menuContactos')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.cliente' })">
          <i class="icon-notebook"></i>
        </div>
        <div class="title">{{ $t("menu.client.client") }}</div>
        <ul
          class="submenu"
          v-show="!open || inSubmenu.cliente || expanded.cliente"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/contactos"
            v-if="$getPermission('contactos.listar')"
          >
            <div class="title">{{ $t("menu.client.contacts") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/cuentas"
            v-if="$getPermission('cuentas.listar')"
          >
            <div class="title">{{ $t("menu.client.accounts") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Actividades Programadas -->
      <li
        :class="{ active: inSubmenu.actividadesprogramadas }"
        @click="expand('actividadesprogramadas')"
        v-if="$getPermission('menuActividadesprogramadas')"
      >
        <div
          class="icon"
          @click="$router.push({ name: 'menu.trabajodecampo' })"
        >
          <i class="fas fa-truck"></i>
        </div>
        <div class="title">
          {{ $t("menu.actividadesprogramadas.actividadesprogramadas") }}
        </div>
        <!--inSubmenu.actividadesprogramadas-->
        <ul
          class="submenu"
          v-show="!open || expanded.actividadesprogramadas"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/actividadesprogramadas"
            v-if="$getPermission('despachador.listar')"
          >
            <div class="title">
              {{ $t("menu.actividadesprogramadas.actividadesprogramadas") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/actividades"
            v-if="$getPermission('actividades.listar')"
          >
            <div class="title">
              {{ $t("menu.actividadesprogramadas.myactivities") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/calendario"
            v-if="$getPermission('calendario.listar')"
          >
            <div class="title">
              {{ $t("menu.actividadesprogramadas.myschedule") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/mapa"
            v-if="$getPermission('actividades.listar')"
          >
            <div class="title">{{ $t("map") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/actividadesprogramadas/configuracion"
            v-if="
              $getPermission(
                '[\'actividadesprogramadas.configuracion\'].listar'
              )
            "
          >
            <div class="title">
              {{ $t("menu.actividadesprogramadas.configuration") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Agente -->
      <li
        :class="{ active: inSubmenu.agente }"
        @click="expand('agente')"
        v-if="$getPermission('menuAgente')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.agente' })">
          <i class="icon-user"></i>
        </div>
        <div class="title">{{ $t("menu.agent.agent") }}</div>
        <ul
          class="submenu"
          v-show="!open || inSubmenu.agente || expanded.agente"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/roles"
            v-if="$getPermission('roles.listar')"
          >
            <div class="title">Roles</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/usuarios"
            v-if="$getPermission('usuarios.listar')"
          >
            <div class="title">{{ $t("menu.agent.users") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/gruposkill"
            v-if="$getPermission('gruposkill.listar')"
          >
            <div class="title">{{ $t("menu.agent.groups") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/conceptos"
            v-if="$getPermission('conceptos.listar')"
          >
            <div class="title">{{ $t("menu.agent.concepts") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/empresas"
            v-if="$getPermission('empresas.listar')"
          >
            <div class="title">{{ $t("menu.agent.companies") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/usuarios/equipo"
            v-if="$getPermission('[\'usuarios.equipo\'].listar')"
          >
            <div class="title">{{ $t("menu.agent.myteamusers") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Llamadas -->
      <li
        :class="{ active: inSubmenu.llamadas }"
        @click="expand('llamadas')"
        v-if="$getPermission('menuLlamadas')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.calls' })">
          <i class="fas fa-phone-alt"></i>
        </div>
        <div class="title">{{ $t("menu.telephone.call") }}</div>

        <ul
          class="submenu"
          v-show="!open || inSubmenu.llamadas || expanded.llamadas"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/calls"
            v-if="$getPermission('calls.listar')"
          >
            <div class="title">{{ $t("menu.telephone.call") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/calls/managment"
            v-if="$getPermission('managmentcalls.listar')"
          >
            <div class="title">{{ $t("menu.telephone.managecalls") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/calls/managment/channel"
            v-if="$getPermission('managmentchannel.listar')"
          >
            <div class="title">{{ $t("menu.telephone.managecallsCh") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Parámetros -->
      <li
        :class="{ active: inSubmenu.casosparametros }"
        @click="expand('casosparametros')"
        v-if="$getPermission('menuParametro')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.parametros' })">
          <i class="icon-options-vertical"></i>
        </div>
        <div class="title">{{ $t("menu.parameterCase.parameterCase") }}</div>
        <ul
          class="submenu"
          v-show="
            !open || inSubmenu.casosparametros || expanded.casosparametros
          "
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/camposper"
            v-if="$getPermission('camposper.listar')"
          >
            <div class="title">{{ $t("menu.parameterCase.customfields") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/sla"
            v-if="$getPermission('sla.listar')"
          >
            <!---->
            <div class="title">{{ $t("menu.parameterCase.slo") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/categorias"
            v-if="$getPermission('categorias.listar')"
          >
            <div class="title">{{ $t("menu.parameterCase.categories") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/prioridades"
            v-if="$getPermission('prioridades.listar')"
          >
            <div class="title">{{ $t("menu.parameterCase.priorities") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/estados"
            v-if="$getPermission('estados.listar')"
          >
            <div class="title">{{ $t("menu.parameterCase.states") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Tipificación -->
      <li
        :class="{ active: inSubmenu.producto }"
        @click="expand('producto')"
        v-if="$getPermission('menuProducto')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.producto' })">
          <i class="fas fa-sitemap"></i>
        </div>
        <div class="title">{{ $t("menu.product.product") }}</div>
        <!--inSubmenu.producto-->
        <ul class="submenu" v-show="!open || expanded.producto" @click.stop="">
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/productos"
            v-if="$getPermission('productos.listar')"
          >
            <div class="title">{{ $t("menu.product.products") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/tipocasos"
            v-if="$getPermission('tipocasos.listar')"
          >
            <div class="title">{{ $t("menu.product.reasonSubtype") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/multityping"
            v-if="$getPermission('multityping.listar')"
          >
            <div class="title">{{ $t("menu.product.multityping") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Procesos -->
      <li
        :class="{ active: inSubmenu.procesos }"
        @click="expand('procesos')"
        v-if="$getPermission('menuProceso')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.proceso' })">
          <i class="fas fa-code-branch"></i>
        </div>
        <div class="title">{{ $t("menu.workflow.workflow") }}</div>
        <!--inSubmenu.procesos-->
        <ul
          class="submenu up"
          v-show="!open || expanded.procesos"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/procesos"
            v-if="$getPermission('procesos.listar')"
          >
            <div class="title">{{ $t("menu.workflow.workflows") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/chequeo"
            v-if="$getPermission('chequeo.listar')"
          >
            <div class="title">{{ $t("menu.workflow.checklist") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/chequeo/script"
            v-if="$getPermission('[\'chequeo.script\'].listar')"
          >
            <div class="title">Script</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/chequeo/html"
            v-if="$getPermission('[\'chequeo.html\'].listar')"
          >
            <div class="title">Html</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/chequeo/aprobacion"
            v-if="$getPermission('[\'chequeo.aprobacion\'].listar')"
          >
            <div class="title">{{ $t("approval.approval") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/chequeo/encuesta"
            v-if="$getPermission('[\'chequeo.encuesta\'].listar')"
          >
            <div class="title">{{ $t("templateSurvey.title") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/sistemasexternos"
            v-if="$getPermission('sistemasexternos.listar')"
          >
            <div class="title">{{ $t("menu.workflow.360views") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Casillas -->
      <li
        :class="{ active: inSubmenu.gestioncasillas }"
        @click="expand('gestioncasillas')"
        v-if="$getPermission('menuGestioncasillas')"
      >
        <div
          class="icon"
          @click="$router.push({ name: 'menu.gestioncasillas' })"
        >
          <i class="fas fa-mail-bulk"></i>
        </div>
        <div class="title">{{ $t("menu.casosCorreos.gestionCasillas") }}</div>
        <ul
          class="submenu"
          v-show="
            !open || inSubmenu.gestioncasillas || expanded.gestioncasillas
          "
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/gestionar/casillascorreos"
            v-if="$getPermission('casillascorreos.listar')"
          >
            <div class="title">
              {{ $t("menu.casosCorreos.gestionarCasillas") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/gestionar/parametrizacioncasoscorreos"
            v-if="$getPermission('parametrizacioncasoscorreos.listar')"
          >
            <div class="title">
              {{ $t("menu.casosCorreos.casosPorCorreos") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Configuración -->
      <li
        :class="{ active: inSubmenu.otros }"
        @click="expand('otros')"
        v-if="$getPermission('menuConfiguracion')"
      >
        <div class="icon" @click="$router.push({ name: 'menu.otros' })">
          <i class="icon-settings"></i>
        </div>
        <div class="title">{{ $t("menu.others.others") }}</div>
        <ul
          class="submenu up"
          v-show="!open || inSubmenu.otros || expanded.otros"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/parametros"
            v-if="$getPermission('parametros.listar')"
          >
            <div class="title">{{ $t("menu.others.parameters") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/parametroswitch"
            v-if="$getPermission('parametroswitch.listar')"
          >
            <div class="title">{{ $t("menu.others.parametersList") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/diasferiados"
            v-if="$getPermission('diasferiados.listar')"
          >
            <div class="title">{{ $t("menu.others.holidays") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/horariosclientes"
            v-if="$getPermission('horariosclientes.listar')"
          >
            <div class="title">{{ $t("menu.others.schedulesSla") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/horarios"
            v-if="$getPermission('horarios.listar')"
          >
            <div class="title">{{ $t("menu.others.schedules") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/zonashorarias"
            v-if="$getPermission('zonashorarias.listar')"
          >
            <div class="title">{{ $t("menu.others.timezones") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/historicoconfiguracion"
            v-if="$getPermission('historicoconfiguracion.listar')"
          >
            <div class="title">
              {{ $t("menu.others.historyConfiguration") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/encuestas"
            v-if="$getPermission('encuestas.listar')"
          >
            <div class="title">{{ $t("menu.others.surveys") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/templatecorreo"
            v-if="$getPermission('templatecorreo.listar')"
          >
            <div class="title">{{ $t("menu.others.template") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/aplicacionesexternas"
            v-if="$getPermission('aplicacionesexternas.listar')"
          >
            <div class="title">
              {{ $t("menu.others.aplicacionesexternas") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/sso"
            v-if="$getPermission('sso.listar')"
          >
            <div class="title">{{ $t("menu.others.sso") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/respuestaspredefinidas"
            v-if="$getPermission('respuestaspredefinidas.listar')"
          >
            <div class="title">{{ $t("menu.others.respPre") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/administrarlistacorreos"
            v-if="$getPermission('adminlistacorreos.listar')"
          >
            <div class="title">{{ $t("menu.others.listEmails") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/segmentacion"
            v-if="$getPermission('segmentacion.listar')"
          >
            <div class="title">{{ $t("menu.others.segmentation") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/keycloak"
            v-if="$getPermission('keycloak.listar')"
          >
            <div class="title">{{ $t("menu.others.keycloak") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/gestordocumental"
            v-if="$getPermission('gestordocumental.listar')"
          >
            <div class="title">{{ $t("documentManager.title") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Traspaso -->
      <router-link
        tag="li"
        active-class="active"
        to="/traspaso/usuarioinstancia"
        exact
        v-if="$getPermission('traspasousuarioinstancia.crear')"
      >
        <div class="icon"><i class="fas fa-share-from-square"></i></div>
        <div class="title">{{ $t("deploy.menu") }}</div>
      </router-link>

      <!-- Reportes -->
      <li
        :class="{ active: inSubmenu.reportesc }"
        @click="expand('reportesc')"
        v-if="$getPermission('menuReportesC')"
      >
        <div
          class="icon"
          @click="$router.push({ name: 'menu.reportesconfig' })"
        >
          <i class="fab fa-readme"></i>
        </div>
        <div class="title">{{ $t("menu.reports.reports") }}</div>
        <ul
          class="submenu up"
          v-show="!open || inSubmenu.reportesc || expanded.reportesc"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/configuracion/reportes"
            v-if="$getPermission('reportes.listar')"
          >
            <div class="title">{{ $t("menu.reports.reports") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/configuraciondash"
            v-if="$getPermission('configuraciondash.listar')"
          >
            <div class="title">{{ $t("firstPage.dashConfig") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/extraccion"
            v-if="$getPermission('extraccion.listar')"
          >
            <div class="title">{{ $t("menu.reports.extraction") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Personalización -->
      <li
        :class="{ active: inSubmenu.personalizacion }"
        @click="expand('personalizacion')"
        v-if="$getPermission('personalizacion.listar')"
      >
        <div class="icon"><i class="fas fa-brush"></i></div>
        <div class="title">{{ $t("personalization.menu") }}</div>
        <ul
          class="submenu up"
          v-show="
            !open || inSubmenu.personalizacion || expanded.personalizacion
          "
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/personalizacion/portal"
          >
            <div class="title">Portal</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/personalizacion/consola"
          >
            <div class="title">Consola</div>
          </router-link>
        </ul>
      </li>
      
      <!-- Proyectos -->
      <li
        :class="{ active: inSubmenu.proyectos }"
        @click="expand('proyectos')"
        v-if="$getPermission('menuProyectos1')"
      >
        <div class="icon"><i class="fas fa-project-diagram"></i></div>
        <div class="title">{{ $t("projectMenu.projectsManagement") }}</div>
        <ul
          class="submenu up"
          v-show="!open || inSubmenu.proyectos || expanded.proyectos"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/proyectos"
            v-if="$getPermission('proyectos.listar')"
          >
            <div class="title">{{ $t("projectMenu.projects") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/proyectos/estadisticas"
            v-if="$getPermission('[\'proyectos.estadisticas\'].listar')"
          >
            <div class="title">{{ $t("projectMenu.statistics") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/proyectos/informes"
            v-if="$getPermission('[\'proyectos.informes\'].listar')"
          >
            <div class="title">{{ $t("projectMenu.progressReports") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/misproyectos"
            v-if="$getPermission('misproyectos.listar')"
          >
            <div class="title">{{ $t("projectMenu.myProjectS") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Licencias -->
      <li
        :class="{ active: inSubmenu.licencias }"
        @click="expand('licencias')"
        v-if="$getPermission('menuLicencias1')"
      >
        <div class="icon"><i class="fas fa-book-open"></i></div>
        <div class="title">{{ $t("licenseMenu.licenses") }}</div>
        <ul
          class="submenu up"
          v-show="!open || inSubmenu.licencias || expanded.licencias"
          @click.stop=""
        >
          <router-link
            tag="li"
            active-class="active"
            to="/licencia"
            v-if="$getPermission('licencia.listar')"
          >
            <div class="title">{{ $t("licenseMenu.licenses") }}</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/company"
            v-if="$getPermission('company.listar')"
          >
            <div class="title">{{ $t("licenseMenu.companies") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Menú Plantillas Outbound-->
      <li
        :class="{ active: inSubmenu.outbound }"
        @click="expand('outbound')"
        v-if="$getPermission('menuOutboundPlantillas')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-comments"></i>
        </div>
        <div class="title">{{ $t("menuOutbound.templates.title") }}</div>
        <ul
          class="submenu"
          v-show="!open || inSubmenu.outbound || expanded.outbound"
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/email"
            v-if="$getPermission('[\'outboundplantillasemail\'].listar')"
          >
            <div class="title">Email</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/push"
            v-if="$getPermission('[\'outboundplantillaspush\'].listar')"
          >
            <div class="title">Push</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/sms"
            v-if="$getPermission('[\'outboundplantillassms\'].listar')"
          >
            <div class="title">SMS</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/whatsapp"
            v-if="$getPermission('[\'outboundplantillaswhatsapp\'].listar')"
          >
            <div class="title">Whatsapp</div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/templates"
            v-if="$getPermission('[\'outboundplantillasaprobacion\'].listar')"
          >
            <div class="title">{{ $t("menuOutbound.templates.approval") }}</div>
          </router-link>
        </ul>
      </li>

      <!-- Menú Reportes Outbound -->
      <li
        :class="{ active: inSubmenu.outboundReport }"
        @click="expand('outboundReport')"
        v-if="$getPermission('menuOutboundReportes')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fab fa-readme"></i>
        </div>
        <div class="title">{{ $t("menuOutbound.outboundReports.title") }}</div>
        <ul
          class="submenu"
          v-show="!open || inSubmenu.outboundReport || expanded.outboundReport"
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/reportesemail"
            v-if="$getPermission('[\'outboundreportes\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundReports.deliveryReportEmail") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/reporteswhatsapp"
            v-if="$getPermission('[\'outboundreportes\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundReports.deliveryReportWhatsapp") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Menú Configuración Outbound -->
      <li
        :class="{ active: inSubmenu.outboundConfig }"
        @click="expand('outboundConfig')"
        v-if="$getPermission('menuOutboundConfiguracion')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-gears"></i>
        </div>
        <div class="title">
          {{ $t("menuOutbound.outboundConfiguration.title") }}
        </div>
        <ul
          class="submenu"
          v-show="!open || inSubmenu.outboundConfig || expanded.outboundConfig"
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/canales"
            v-if="$getPermission('[\'outboundconfiguracioncanales\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.channels") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/estados"
            v-if="$getPermission('[\'outboundconfiguracionestados\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.statuses") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/feriados"
            v-if="$getPermission('[\'outboundconfiguracionferiados\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.holidays") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/horarios"
            v-if="$getPermission('[\'outboundconfiguracionhorarios\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.schedules") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/parametros"
            v-if="
              $getPermission('[\'outboundconfiguracionparametros\'].listar')
            "
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.parameters") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/lineas"
            v-if="$getPermission('[\'outboundconfiguracionlinea\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.line") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/sublineas"
            v-if="$getPermission('[\'outboundconfiguracionsublinea\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.subline") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/codigo"
            v-if="$getPermission('[\'outboundconfiguracioncodigo\'].listar')"
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.code") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/excepciones"
            v-if="
              $getPermission('[\'outboundconfiguracionexcepciones\'].listar')
            "
          >
            <div class="title">
              {{ $t("menuOutbound.outboundConfiguration.exceptions") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            to="/outbound/configuracion/variables"
            v-if="
              $getPermission('[\'outboundconfiguracionvariables\'].listar')
            "
          >
            <div class="title">
              Variables
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Menú creacion pantallas hyperpersonalizacion -->
      <li
        :class="{ active: inSubmenu.hyperpersonalization }"
        @click="expand('hyperpersonalization')"
        v-if="$getPermission('hyperpersonalizacion')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-plus"></i>
        </div>
        <div class="title">{{ $t("hyperpersonalization.creation.title") }}</div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.hyperpersonalization ||
            expanded.hyperpersonalization
          "
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpformulariohyperpersonalizacion'}"
            v-if="
              $getPermission('[\'hpformulariohyperpersonalizacion\'].listar')
            "
          >
            <div class="title">
              {{ $t("hyperpersonalization.creation.hpformulario") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpadministracionhyperpersonalizacion'}"
            v-if="
              $getPermission(
                '[\'hpadministracionhyperpersonalizacion\'].listar'
              )
            "
          >
            <div class="title">
              {{ $t("hyperpersonalization.creation.hpadministracion") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpaprobacionhyperpersonalizacion'}"
            v-if="
              $getPermission('[\'hpaprobacionhyperpersonalizacion\'].listar')
            "
          >
            <div class="title">
              {{ $t("hyperpersonalization.creation.hpaprobacion") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Menú pantallas creadas hyperpersonalizacion -->
      <li
        :class="{ active: inSubmenu.hyperpersonalizationCreated }"
        @click="expand('hyperpersonalizationCreated')"
        v-if="$getPermission('hyperpersonalizacionCreated')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-list"></i>
        </div>
        <div class="title">{{ $t("hyperpersonalization.created.title") }}</div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.hyperpersonalizationCreated ||
            expanded.hyperpersonalizationCreated
          "
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hppantallahyperpersonalizacion'}"
            v-if="$getPermission('[\'hppantallahyperpersonalizacion\'].listar')"
          >
            <div class="title">
              {{ $t("hyperpersonalization.created.listScreens") }}
            </div>
          </router-link>
        </ul>
      </li>

      <li
        :class="{ active: inSubmenu.hyperpersonalizationCreated }"
        @click="expand('hyperpersonalizationCreated')"
        v-if="$getPermission('hyperpersonalizacionCreated')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-regular fa-list-alt"></i>
        </div>
        <div class="title">{{ $t("hyperpersonalization.list.agent") }}</div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.hyperpersonalizationCreated ||
            expanded.hyperpersonalizationCreated
          "
          :class="{ up: menuUp }"
        >
          <template v-for="form in allAgentViews">
            <router-link        
              v-if="$getPermission(`HYPER-${form.nombreUrl || form.nombre.replaceAll(' ', '-')}.ver`)"
              :key="form.id"
              tag="li"
              active-class="active"
              :to="{name: 'hpagentform', params: {name: form.nombreUrl || form.nombre.replaceAll(' ', '-')}}"
            >
              <div class="title">
                {{ form.nombre }}
              </div>
            </router-link>
          </template>
        </ul>
      </li>

      <li
        :class="{ active: inSubmenu.hyperpersonalizationCreated }"
        @click="expand('hyperpersonalizationCreated')"
        v-if="$getPermission('hyperpersonalizacionCreated')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-list-alt"></i>
        </div>
        <div class="title">{{ $t("hyperpersonalization.list.user") }}</div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.hyperpersonalizationCreated ||
            expanded.hyperpersonalizationCreated
          "
          :class="{ up: menuUp }"
        >
          <template v-for="form in allUserViews">
            <router-link
              v-if="$getPermission(`HYPER-${form.nombreUrl || form.nombre.replaceAll(' ', '-')}.ver`)"
              :key="form.id"
              tag="li"
              active-class="active"
              :to="{name: 'hpuserform', params: {name: form.nombreUrl || form.nombre.replaceAll(' ', '-')}}"
            >
              <div class="title">
                {{ form.nombre }}
              </div>
            </router-link>
          </template>
        </ul>
      </li>
      <li
        :class="{ active: inSubmenu.reporteshp }"
        @click="expand('reporteshp')"
        v-if="$getPermission('reporteshp.ver')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fab fa-readme"></i>
        </div>
        <div class="title">{{ $t("hyperpersonalization.reportes") }}</div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.reporteshp ||
            expanded.reporteshp
          "
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'reporteshp', params: {}}"
          >
            <div class="title">
              {{ $t('menu.reports.reports') }}
            </div>
          </router-link>
        </ul>
      </li>
      <!-- Menú Configuración hyperpersonaliiización -->
      <li
        :class="{ active: inSubmenu.hyperpersonalizationConfig }"
        @click="expand('hyperpersonalizationConfig')"
        v-if="$getPermission('hyperpersonalizacionConfig')"
      >
        <div class="icon" @mouseover="checkMenuDirection">
          <i class="fa-solid fa-gears"></i>
        </div>
        <div class="title">
          {{ $t("hyperpersonalization.configuration.title") }}
        </div>
        <ul
          class="submenu"
          v-show="
            !open ||
            inSubmenu.hyperpersonalizationConfig ||
            expanded.hyperpersonalizationConfig
          "
          :class="{ up: menuUp }"
        >
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpconfiguracionhyperpersonalizacion'}"
            v-if="
              $getPermission('[\'hpconfiguracionhyperpersonalizacion\'].listar')
            "
          >
            <div class="title">
              {{ $t("hyperpersonalization.configuration.configurations") }}
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpscripts'}"
            v-if="
              $getPermission('[\'hpscripts\'].listar')
            "
          >
            <div class="title">
              Scripts
            </div>
          </router-link>
          <router-link
            tag="li"
            active-class="active"
            :to="{name: 'hpdefiniciones'}"
            v-if="
              $getPermission('[\'hpdefiniciones\'].listar')
            "
          >
            <div class="title">
              {{ $t("hyperpersonalization.configuration.definitions") }}
            </div>
          </router-link>
        </ul>
      </li>

      <!-- Catálogo de Documentos -->
      <router-link
        tag="li"
        active-class="active"
        to="/catalogodocumentos"
        v-if="$getPermission('catalogodocumentos.listar')"
      >
        <div class="icon"><i class="fa-solid fa-folder-open"></i></div>
        <div class="title">{{ $t("documentCatalog.title") }}</div>
      </router-link>
    </ul>
  </scrollbar>
</template>

<style lang="scss" scoped>
li:hover {
  background-color: color-mix(in srgb, var(--background) 70%, white);
}

li > .submenu {
  background-color: var(--background);
}

.active {
  background-color: color-mix(in srgb, var(--background) 90%, white);
}

.sidebarUserActions {
  li {
    display: flex !important;
    flex-direction: row !important;
    height: 35px !important;
    justify-content: center !important;
    align-items: center !important;
    padding: 0;
    margin-left: 0 !important;
    margin: 15 !important;
    flex-grow: 2;

    i {
      margin-left: 0 !important;
      margin: 0 !important;
      display: flex !important;
      justify-content: center;
    }

    span {
      width: 80%;
      margin-left: 5px;
      margin-bottom: 0px;
      margin-right: 0px;
    }
  }
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Vue from "vue";

export default {
  data: () => ({
    userMenu: false,
    expanded: {},
    allRedash: [],
    menuUp: false
  }),
  computed: {
    open() {
      return this.$store.state.open;
    },
    inSubmenu() {
      return {
        casos: this.$route.path.indexOf(["casos"]) >= 0,
        actividadesprogramadas:
          this.$route.path.indexOf(["actividadesprogramadas"]) >= 0,
        proyectos: this.$route.path.indexOf(["proyectos"]) >= 0,
        licencias: this.$route.path.indexOf(["licencias", "company"]) >= 0,
        configuracion: this.$route.path.indexOf(["configuracion"]) >= 0,
        dashboardview: this.$route.path.indexOf(["dashboardview"]) >= 0,
        reportesc: this.$route.path.indexOf(["reportesc"]) >= 0,
        reporteS: this.$route.path.indexOf(["reporteS"]) >= 0,
        producto: this.$route.path.indexOf(["producto"]) >= 0,
        casosparametros: this.$route.path.indexOf(["casosparametros"]) >= 0,
        agente: this.$route.path.indexOf(["agente"]) >= 0,
        cliente: this.$route.path.indexOf(["cliente"]) >= 0,
        procesos: this.$route.path.indexOf(["procesos"]) >= 0,
        gestioncasillas: this.$route.path.indexOf(["gestionar"]) >= 0,
        llamadas: this.$route.path.indexOf(["llamadas"]) >= 0,
        personalizacion: this.$route.path.includes("/personalizacion"),
        traspaso: this.$route.path.includes("/traspaso"),
        outbound: this.$route.path.includes("/outbound") && (this.$route.path.includes('/templates') || this.$route.path.includes('/whatsapp') || this.$route.path.includes('/sms') || this.$route.path.includes('/push') || this.$route.path.includes('/email')),
        outboundReport: this.$route.path.includes("/outbound/reportes"),
        outboundConfig: this.$route.path.includes("/outbound/configuracion"),
        hyperpersonalization: this.$route.path.includes("/hyperpersonalizacion"),
        hyperpersonalizationCreated:
          this.$route.path.includes("/hyperpersonalizacion/process"),
        hyperpersonalizationConfig: this.$route.path.includes(
          "/hyperpersonalizacion/configuracion"
        ),
        catalogodocumentos: this.$route.path.includes("/catalogodocumentos"),
      };
    },
    stateOfAzure() {
      return this.$store.state.auth.activeAzure;
    },
    sideBarColors() {
      if (this.theme.activo && this.theme.sidebar && this.theme.fuenteiconos) {
        return `background-color: ${this.theme.sidebar}; color: ${this.theme.fuenteiconos}`;
      } else {
        return "background-color: #011c21; color: #ffffffb3";
      }
    },
    ...mapGetters("auth", ["user", "company", 'token']),
    ...mapGetters("personalizacionDesk", { theme: "one" }),
    ...mapGetters("parametros", { allParameters: "all" }),
    ...mapGetters('hyperpersonalization', ['allAgentViews', 'allUserViews']),
    ...mapGetters('navegacion', { allNavegation: 'all' })
  },
  watch: {
    open(value) {
      if (!value) {
        this.$refs.scrollbar.scrollToY(0);
      }
    },
  },
  methods: {
    checkMenuDirection(event) {
      this.menuUp = event.clientY > window.innerHeight / 2;
    },
    ...mapMutations('hyperpersonalization', ['setUserViews', 'setAgentViews']),
    ...mapMutations('navegacion', { setNavegacion: 'setOne' }),
    ...mapActions("redashboard", { getAllDashes: "getAll" }),
    ...mapActions("personalizacionDesk", { getTheme: "getBy" }),
    ...mapActions("parametros", { getAllParameters: "getAll" }),
    ...mapActions('navegacion', { saveNavegation: 'save', getAllNavegation: 'getAll' }),
    async getHyperForms() {
      await this.getAllNavegation()
      const myHeaders = new Headers();
      myHeaders.append('X-BA360-Company', this.company);
      myHeaders.append("Authorization", `Bearer ${btoa(`${this.company}/${this.user.user}:${this.token}`)}`);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders
      };
      const baseUrl = this.allParameters.find(parameter => parameter.key === 'HYPERPERSONALIZATION_API_URL').value
      const [agentResponse, userResponse] = await Promise.all([
        fetch(`${baseUrl}/agentformschema/getAllByStateAndWord?size=100&state=activo&word`, requestOptions),
        fetch(`${baseUrl}/userformschema/search/findUserFormSchemaByEstadoAndWord?size=100&state=activo&word`, requestOptions)
      ])
      const [jsonAgentResponse, jsonUserResponse] = await Promise.all([
        agentResponse.json(),
        userResponse.json()
      ])
      this.setAgentViews(jsonAgentResponse.content)
      this.setUserViews(jsonUserResponse._embedded.userFormSchemas)
      this.createPermission()
    },
    createPermission() {
      for(const view of this.allAgentViews) {
        if(this.allNavegation.find(navegation => navegation.descripcion === `HYPER ${view.nombre}`)?.id) continue
        this.setNavegacion({
          idnavegacion: null,
          icono: null,
          descripcion: `HYPER ${view.nombre}`,
          path: `HYPER-${view.nombreUrl || view.nombre.replaceAll(' ', '-')}`
        })
        this.saveNavegation()
      }
      for(const view of this.allUserViews) {
        if(this.allNavegation.find(navegation => navegation.descripcion === `HYPER ${view.nombre}`)?.id) continue
        this.setNavegacion({
          idnavegacion: null,
          icono: null,
          descripcion: `HYPER ${view.nombre}`,
          path: `HYPER-${view.nombreUrl || view.nombre.replaceAll(' ', '-')}`
        })
        this.saveNavegation()
      }
    },
    getAll() {
      this.$store
        .dispatch("redashboard/custom", {
          method: "get",
          endpoint: "redashboard/getmisdash",
        })
        .then((response) => {
          this.allRedash = response;
        })
        .catch(() => {
          this.$notification("error");
        });
    },
    expand(key) {
      if (this.open) {
        const value = !this.expanded[key];
        this.$set(this.expanded, key, value);
      }
    },
    profile() {
      this.$router.push({ name: "perfil" });
      this.userMenu = false;
    },
    logout() {
      this.$store
        .dispatch("usuarios/custom", {
          method: "post",
          endpoint: "usuario/estado/add",
          dataToSend: { tipoconcepto: 0 },
        })
        .then(() => {
          if (this.stateOfAzure === "SI") {
            this.$store.dispatch("auth/logout").then(() => {
              window.location.href = "/logoutAzure";
            });
          } else {
            this.$store.dispatch("auth/logout").then(() => {
              if (Vue.$keycloak) {
                if (Vue.$keycloak.authenticated) {
                  return;
                }
              }
              window.location.href = "/";
            });
          }
        });
      this.userMenu = false;
    },
  },
  watch: {
    allParameters(newvalue, oldvalue) {
      const oldHpApiUrl = oldvalue.find(parameter => parameter.key === 'HYPERPERSONALIZATION_API_URL')?.value
      const newHpApiUrl = newvalue.find(parameter => parameter.key === 'HYPERPERSONALIZATION_API_URL')?.value
      if(!oldHpApiUrl && newHpApiUrl) this.getHyperForms()
    }
  },
  mounted() {
    this.getAll();
  }
};
</script>
